import { Swarm } from '@lbs/swarm-client';

import Config from '@skin_config';
import { SWARM_CONFIG_DATA } from './actionTypes';

/**
 * @description Set partner initial configs
 * @param {Object} message
 * @param {String} key
 * @returns {Object} new State
 */
export const SwarmConfigData = (message, key) => ({
  type: SWARM_CONFIG_DATA,
  payload: message,
  key,
});

export const LoadCurrencyConfig = (currencyName) => (
  async (dispatch) => {
    const updateCurrencyConfig = (data) => {
      const currencies = {};
      Object.keys(data.currency).forEach((id) => {
        currencies[data.currency[id].name] = data.currency[id];
      });
      dispatch(SwarmConfigData(currencies, 'currency'));
    };

    try {
      const response = await Swarm.getInstance()
        .subscribe({
          source: 'config.currency',
          what: { currency: [] },
          where: {
            currency: { name: currencyName },
          },
        }, updateCurrencyConfig, true);

      return updateCurrencyConfig(response.data);
    } catch (ex) {
      console.error('CurrencyConfig load failed:', ex);
      return null;
    }
  }
);
